// extracted by mini-css-extract-plugin
export default {"pageContainer":"EventPageLayout_pageContainer__CLxCI","pageWrapper":"EventPageLayout_pageWrapper__fhX2d"};